<template>
 <page>
  
   <head-nav title="language.update_photoalbum">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

  <scroll-page>
    <page-padding>
      
      <ui-input title="language.title" type="text" v-bind:val="title" @input="(v)=>{title = v}"></ui-input>
      <!--<ui-textarea title="language.provide_description" v-bind:val="description" @input="(v)=>{description = v}"></ui-textarea>-->
      <ui-htmlarea title="language.provide_description" v-bind:val="description" @input="(v)=>{bb_description = v}"></ui-htmlarea>
      
      <!-- pick images mobile variant -->
      <button-action v-if="isMobile" :active="computeUploadImagesLeft>0" v-on:click.native="getGalleryImages()" title="language.gallery" ></button-action>

      <!-- pick images desktop variant -->
      <button-file v-if="!isMobile" :active="computeUploadImagesLeft>0" :multiple="true" accept="image/jpeg,image/png" title="language.gallery" @change="getGalleryImagesBrowser"></button-file>




      </page-padding>
      <upload-gallery :key="mediaKey" :medias="medias"/>
      
      <page-padding>
      
      <fold-button v-if="computeShowFolder" title="language.delete_existing_images">
          <caroussel-gallery @selection="getSelection" :mode="gallery_mode" :medias="album.items"/>
      </fold-button>
     
      <!--ui-check :val="check.app" v-on:selected="val=>{check.app = val}" title="language.place_in_schoolapp" />-->
      <ui-check val="{true}" :disabled="true" v-on:selected="val=>{check.app = val}" title="language.place_in_schoolapp" />
      <ui-check :val="check.website" v-on:selected="val=>{check.website = val}" title="language.place_on_website" />
      <!--<ui-check :val="check.narrowcasting" v-on:selected="val=>{check.narrowcasting = val}" title="language.place_on_narrow" />-->
     
     <divider title=""/>
      <button-activate :active="buttonActive" v-on:click.native="confirm()" :title="computeTitle"></button-activate>
     
     </page-padding>
   </scroll-page>
   </page>
</template>

<script>


import { mapState } from 'vuex';
import ButtonActivate from '../components/buttons/ButtonActivate.vue';
import ButtonAction from '../components/buttons/ButtonAction.vue';
import PagePadding from '../components/PagePadding.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import UiCheck from '../components/UiCheck.vue'
import UiInput from '../components/UiInput.vue';
import UiHtmlarea from '../components/UiHtmlarea.vue';
import UploadGallery from '../components/uploadGallery/UploadGallery.vue';
import ScrollPage from '../components/ScrollPage.vue';
import { imagePicker } from '../services/ImagePicker.js'
import { api } from '../services/Api';
import Page from '../pages/Page.vue';
import { modalService } from '../services/ModalService';
import i18n from "../language.js";
import { fileTransfer } from '../services/FileTransfer.js';
import { eventBus } from '../services/EventBus.js';
import Vue from 'vue';
import { history } from "../services/History.js";
import Divider from '../components/dividers/Divider.vue';
import { GALLERY_MODE }  from '../components/caroussel/GALLERY_MODE.js';
import CarousselGallery from '../components/caroussel/CarousselGallery.vue';
import FoldButton from '../components/buttons/FoldButton.vue'
import ButtonFile from '../components/buttons/ButtonFile.vue';
import { cordovaInit } from '../services/CordovaInit.js';

export default {
  name: 'update-photoalbum-page',
  data:function(){
    return{
      gallery_mode:GALLERY_MODE.SELECT_MULTIPLE,
      id:this.$route.params.id, /* group id*/
      album_id:this.$route.params.album_id,
      buttonActive:true,
      maxImages:20,
      medias:[],
      mediaKey:0,
      delete_ids:[], // list with photo ids to delete
      title:"",
      description:"",
      bb_description:"",
      group:{ name:"no-name" },
      check:{ // non persistent
        //app:false,
        website:false,
        //narrowcasting:false,
      },
      isMobile:cordovaInit.isMobile(),
    }
  },
  computed:{
    ...mapState([
       'groups','appSettings','user_schools','album'
       ]),
      upload_path:function(){
        var school=this.user_schools.find(school => school.active === 1);
        return api.getUrl(school,"add_album_photo.php");
      },
      computeTitle(){
        if(!this.buttonActive){
          return this.$t('language.working');
        }else{
           return this.$t('language.update_photoalbum');
        }
      },
      computeUploadImagesLeft(){
        
        var imagesLeft=this.maxImages-this.medias.length;
        if(imagesLeft<0){ imagesLeft=0;}
        return imagesLeft;
      },
      computeShowFolder(){
        return this.album.items ? this.album.items.length:false;
      },
  },
  components: {
    ButtonActivate,
    ButtonAction,
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    UiInput,
    UiHtmlarea,
    UiCheck,
    UploadGallery,
    Page,
    ScrollPage,
    Divider,
    CarousselGallery,
    FoldButton,
    ButtonFile,
  },
  methods:{
    back(){
      this.$router.push(history.get());
    },
     getSelection(selected){
      this.delete_ids=selected.map((index)=>{
        return this.album.items[index].id
      })
    },
    isFormComplete(){

      if(this.title===""){
          modalService.createAlert(i18n.t('language.form_incomplete_title'))
        return false;
      }

      return true
    },
    getGalleryImages(){

      this.buttonActive=false;
      
       var args = {
        'selectMode': imagePicker.mediaType.IMAGE, //101=picker image and video , 100=image , 102=video
        'maxSelectCount': this.computeUploadImagesLeft, //default 40 (Optional)
        'maxSelectSize': 15000000, //180000000=180M (Optional) only android (15000000 15 mb)
      };
      

      imagePicker.getMedias(args).then( medias => {
        this.buttonActive=true;

        var c=0;
        medias.forEach(media=>{
          setTimeout(()=>{
            this.medias.push(media)
          },c*50);
          c++;
           
        })
        
      })

      
    },
    getGalleryImagesBrowser(e){
      
      this.buttonActive=false;

      imagePicker.fileListToMedias(e.target.files).then(result=>{
        
        var c=0;
        result.forEach(media=>{
          setTimeout(()=>{
            
             this.medias.push(media)
          },c*50);
          c++;
           
        })

        this.buttonActive=true;
      })

    },
    confirm(){
      if(!this.isFormComplete()){
        return;
      }

      this.buttonActive=false;

      this.updateAlbum();
     
    
    },
    loadAlbum(){
      // load album
      var payload={id:this.album_id}
      this.$store.dispatch('get_album',payload).then(()=>{

        // get back checks also
        this.title=this.album.title;
        this.description=this.album.description;
      
        //this.check.app=parseInt(this.album.app);
        this.check.website=parseInt(this.album.website);
        //this.check.narrowcasting=parseInt(this.album.narrowcasting);
       

      })
    },
    updateAlbum(){
      // first create album
      var payload={
        id:this.album_id,
        text:this.bb_description,
        title:this.title,
        delete_photos:this.delete_ids,
        website:this.check.website ? 1 : 0,
        //narrowcasting:this.check.narrowcasting ? 1 : 0,
      }
      
      
      this.$store.dispatch('update_album',payload).then(()=>{
       
        // start uploading medias first item
        this.uploadNextFile(this.album_id,0);
      });
      
      

    },
    allUploadFinished(){
        this.buttonActive=true;
        this.medias=[];
       
        
        Vue.$toaster.toast("language.album_updated");
       
       this.back();

    },
    uploadNextFile(album_id,index){
     
      if(index>=this.medias.length){
        this.allUploadFinished()
        return;
      }
      var media=this.medias[index];
      
      var params={
        group_id:this.group ? this.group.id : 0,
        file_name:"none.jpg",
        album_id:album_id,
        exif_orientation:media.exifOrientation.toString(),
        sort:index,
        token:this.appSettings.token,
      }
      
      var payload={media}
      eventBus.$emit("MEDIA_UPLOAD_START",payload);
      
     
     fileTransfer.uploadFile(media.url,this.upload_path,params).then(()=>{
        var payload={media}
        // start animate out
        eventBus.$emit("MEDIA_UPLOAD_DONE",payload);
        
        // allow animation to finish
        setTimeout(()=>{
          index++;
          this.uploadNextFile(album_id,index);
        },400)
        
      },error=>{
        alert("filetransfer error: "+error)
        this.buttonActive=true;
      })
      
    },

    addListeners(){
      eventBus.$on('UPLOAD_GALLERY_LOADING_DONE',()=>{
        this.buttonActive=true;
      })
    },
    removeListeners(){
      eventBus.$off('UPLOAD_GALLERY_LOADING_DONE');
    }

  },
  beforeDestroy(){
    this.removeListeners();
  },
  
  updated(){
  },
  mounted(){
      // get group by id
      this.group = this.groups.find(group => group.id === this.id);
      
       // load current album data
      this.loadAlbum();

      this.addListeners();
      
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbnail{
  width:100%;
  height:auto;
}
</style>
